
const env = process.env.NODE_ENV;
const isDevelopment = env === "development";
const setData: boolean = true;

const InitPage: number = 0;
const TotalPage: number = 5;

const IHDataTemp: IIncendioHogarCR = {
    init: false,
    identificationType: '',
    identification: '',
    firstName1: '',
    firstName2: '',
    lastName1: '',
    lastName2: '',
    phoneNumber: '',
    mail: '',
    acceptTerms: false,
    province: '',
    canton: '',
    district: '',
    neighborhood: '',
    address: '',
    yearConstruction: '',
    currency: '',
    paymentFrequency: '',
    idPlan:'',
    lstTypeBien:[],
    lstCoverages:[],
    lstRate:[],
    planConfig: {},
    typeBien_Id1: 0,
    typeBien_Id2: 0,
    typeBien_Id3: 0,
    saved: false,
    summary: undefined,
    numberPolicy: 0
}

const IHDataTempWithData: IIncendioHogarCR = {
    init: false,
    identificationType: '3',
    identification: '1234567',
    firstName1: 'Eddy',
    firstName2: 'Antonio',
    lastName1: 'Ortiz',
    lastName2: 'Amador',
    phoneNumber: '57989684',
    mail: 'eortiza@lafise.com',
    acceptTerms: true,
    province: '',
    canton: '',
    district: '',
    neighborhood: '',
    address: 'test',
    yearConstruction: '1991',
    currency: '',
    paymentFrequency: '',
    idPlan:'',
    lstTypeBien:[],
    lstCoverages:[],
    lstRate:[],
    planConfig: {},
    typeBien_Id1: 0,
    typeBien_Id2: 150000,
    typeBien_Id3: 3000,
    saved: true,
    summary: undefined,
    numberPolicy: 463769
}


const setObj = () => (setData && isDevelopment) ? ({ ...IHDataTempWithData }) : ({ ...IHDataTemp });

const IncendioHogarDefault: IIncendioHogarCR = setObj();

export { IncendioHogarDefault, InitPage, TotalPage };